export const PAGE_ARCHITECTURE_KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/pages-architecture'
